import type { FaqItem } from "@/components/shared/FAQ";
import type { HomeContent } from "../types";

export const HI_FAQS: FaqItem[] = [
  {
    question: "क्या मैं अपना plan cancel कर सकता हूँ?",
    answer:
      "हाँ। आप settings से कभी भी अपना plan cancel कर सकते हैं। आपका plan billing cycle के अंत तक active रहेगा।",
  },
  {
    question: "Workflow credit क्या है?",
    answer:
      "एक workflow credit यानी Crayo की AI से बना एक video। इसमें AutoClip और दूसरे workflows शामिल हैं।",
  },
  {
    question: "मैं अपना usage कैसे देखूँ?",
    answer:
      "आप settings में अपना usage देख सकते हैं। ऊपर दाईं ओर अपनी profile photo पर click करें।",
  },
  {
    question: "क्या आपकी कोई refund policy है?",
    answer:
      "माफ़ कीजिए, हम refund नहीं देते। आप कभी भी plan cancel कर सकते हैं और वह billing cycle के अंत तक active रहेगा।",
  },
  {
    question: "Export minute क्या होता है?",
    answer:
      "Export minute वह video की लंबाई है जो आप Crayo से बना सकते हैं। उदाहरण के लिए, 60 export minutes में आप 1 minute का video 60 बार बना सकते हैं।",
  },
  {
    question: "क्या मैं Crayo से बने videos से पैसे कमा सकता हूँ?",
    answer: "हाँ। Crayo से बनाए videos के सारे rights पूरी तरह आपके हैं।",
  },
  {
    question: "क्या मैं दूसरी भाषाओं में generate कर सकता हूँ?",
    answer:
      "हाँ। हम ज़्यादातर भाषाएँ support करते हैं। बस जिस भाषा में generate करना है, उसी में text दें। अगर कोई भाषा उपलब्ध नहीं है तो support से संपर्क करें।",
  },
  {
    question: "क्या बचे हुए credits अगले महीने carry होते हैं?",
    answer:
      "Subscription credits हर plan term पर हर महीने refill होते हैं, चाहे आप monthly, quarterly या yearly pay करें, और बचे हुए credits carry forward नहीं होते। One-time top-up के credits आपके monthly allowance से अलग होते हैं।",
  },
];

export const HI_HOME: HomeContent = {
  seoTitle: "Crayo: AI से clips बनाने वाला video editor",
  seoDescription:
    "Short-form video के लिए AI video editor। Auto clipping, AI voiceovers, captions और बहुत कुछ। सेकंडों में viral shorts बनाएं।",
  heading: {
    prefix: "आपका",
    highlight: "#1 Clipping Tool",
    suffix: "AI से viral videos edit करें",
  },
  body: "Auto clipping, AI voiceovers, engaging subtitles और बहुत कुछ के लिए आपका all-in-one tool।",
  mobileBody: "Editing के लिए आपका all-in-one platform।",
  faqs: HI_FAQS,
};
